export const CT_COLOR = "#5ab8f4";
export const T_COLOR = "#f0c941";
export const BOMB_COLOR = "#FF8200";
